import { createFileRoute } from "@tanstack/react-router";

import { PluginManagePage } from "../components/plugins/PluginManagePage";

export const Route = createFileRoute("/_chat/plugins/manage")({
  component: PluginManagePage,
});
